var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEd5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    enableBackground: "new 0 0 64 64",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m62 1h-55c-.265 0-.52.105-.707.293l-5 5c-.188.187-.293.442-.293.707v50c0 .265.105.52.293.707l5 5c.187.188.442.293.707.293h53c.552 0 1-.448 1-1v-5.586l1.707-1.707c.188-.187.293-.442.293-.707v-52c0-.552-.448-1-1-1zm-47 28v2.184c-1.161.414-2 1.514-2 2.816s.839 2.402 2 2.816v2.184h-.184c-.414-1.161-1.514-2-2.816-2s-2.402.839-2.816 2h-6.184v-10zm1 6c-.551 0-1-.449-1-1s.449-1 1-1 1 .449 1 1-.449 1-1 1zm-3 5c0 .551-.449 1-1 1s-1-.449-1-1 .449-1 1-1 1 .449 1 1zm48 13.586-1.707 1.707c-.188.187-.293.442-.293.707v5h-51.586l-4.414-4.414v-15.586h2v5c0 .265.105.52.293.707l1.707 1.707v4.586h2v-5c0-.265-.105-.52-.293-.707l-1.707-1.707v-4.586h2.184c.414 1.161 1.514 2 2.816 2s2.402-.839 2.816-2h1.184c.552 0 1-.448 1-1v-3.184c1.161-.414 2-1.514 2-2.816s-.839-2.402-2-2.816v-3.184-2.586l1.707-1.707c.188-.187.293-.442.293-.707v-4h-2v3.586l-1.707 1.707c-.188.187-.293.442-.293.707v2h-2v-5h-2v5h-4v-2.586l1.707-1.707c.188-.187.293-.442.293-.707v-5h-2v4.586l-1.707 1.707c-.188.187-.293.442-.293.707v3h-2v-19.586l4.414-4.414h53.586z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 37c1.654 0 3-1.346 3-3s-1.346-3-3-3-3 1.346-3 3 1.346 3 3 3zm0-4c.551 0 1 .449 1 1s-.449 1-1 1-1-.449-1-1 .449-1 1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57 5h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57 9h2v4h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57 15h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53 5h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53 9h2v4h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53 15h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49 5h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49 9h2v4h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49 15h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45 5h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45 9h2v4h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45 15h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41 5h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41 9h2v4h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41 15h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37 5h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37 9h2v4h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37 15h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33 5h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33 9h2v4h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33 15h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29 5h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29 9h2v4h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29 15h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 5h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 9h2v4h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 15h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21 5h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21 9h2v4h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21 15h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17 5h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17 9h2v4h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17 15h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 5h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 9h2v4h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 15h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29 47h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29 51h2v4h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29 57h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 47h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 51h2v4h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 57h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21 47h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21 51h2v4h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21 57h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17 47h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17 51h2v4h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17 57h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 47h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 51h2v4h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 57h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51 35c0 .552.448 1 1 1h6c.552 0 1-.448 1-1v-14c0-.552-.448-1-1-1h-6c-.552 0-1 .448-1 1zm2-13h4v12h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58 38h-6c-.552 0-1 .448-1 1v14c0 .552.448 1 1 1h6c.552 0 1-.448 1-1v-14c0-.552-.448-1-1-1zm-1 14h-4v-12h4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48 33h-1v-4h-2v4h-2v-4h-2v4h-2v-4h-2v4h-1-8v2h7v2h-7c-.265 0-.52.105-.707.293l-1.707 1.707h-3.586v2h4c.265 0 .52-.105.707-.293l1.707-1.707h6.586v2h-5c-.265 0-.52.105-.707.293l-1.707 1.707h-3.586v2h4c.265 0 .52-.105.707-.293l1.707-1.707h5.586 1v4h2v-4h2v3.586l-1.707 1.707c-.188.187-.293.442-.293.707v4h2v-3.586l1.707-1.707c.188-.187.293-.442.293-.707v-4h2v4h2v-4h1c.552 0 1-.448 1-1v-8c0-.552-.448-1-1-1zm-1 8h-10v-6h10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54 23h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54 31h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54 41h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54 49h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22 19h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31 19h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22 29h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31 29h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 19h5v2h-5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31 22h2v6h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 29h5v2h-5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22 22h2v6h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38 25c1.654 0 3-1.346 3-3s-1.346-3-3-3-3 1.346-3 3 1.346 3 3 3zm0-4c.551 0 1 .449 1 1s-.449 1-1 1-1-.449-1-1 .449-1 1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46 25c1.654 0 3-1.346 3-3s-1.346-3-3-3-3 1.346-3 3 1.346 3 3 3zm0-4c.551 0 1 .449 1 1s-.449 1-1 1-1-.449-1-1 .449-1 1-1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEd5);
export default __webpack_public_path__ + "static/media/ED5.0c1526c0.svg";
export { ForwardRef as ReactComponent };